<template>

  <tr class="detail">
    <td colspan="10">
      <h4>출입자 상세정보</h4>
      <div class="result-tbl m-t-sm">
        <table class="tbl">
          <tbody>

            <tr>
            <col-field  label="티켓 번호">
              <Input :value="item.ntreeTicket" placeholder="티켓 번호"/>
            </col-field>
            <th>출입요청 기간</th>
            <td>{{getDueDate(item.fromDate, item.toDate)}}</td>
          </tr>
          <tr>
            <th>이름

            </th>
            <td>{{item.visitorName}}</td>
            <th>회사명
            </th>
            <td>{{item.visitorCompany}}
            </td>
          </tr>
          <tr>
            <th>담당자
              <!--button class="btn btn-sm line-3 ml-5">Edit</button-->
            </th>
            <td>{{item.empName}}</td>
            <th>방문목적</th>
            <td>{{getVisitType(item)}}
            </td>
          </tr>
          <tr>
            <th>상태
            </th>
            <td><i :class="['dot', getStatus(item)]"></i> {{item.visitStatus.statusStr}}</td>

          </tr>
        </tbody></table>
      </div>
      <h4 class="mt-20">반입자산</h4>
      <table class="tbl outline m-t-sm">
        <colgroup>
          <col width="10%">
          <col width="20%">
          <col width="20%">
          <col width="20%">
          <col width="30%">
        </colgroup>
        <thead>
        <tr>
          <th>항목</th>
          <th>제조사</th>
          <th>모델명</th>
          <th>시리얼번호</th>
          <th>비고</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(asset, assetIndex) in item.assetList" :key="assetIndex">
          <td>{{asset.assetCode}}</td>
          <td>{{asset.assetManufacturer}}</td>
          <td>{{asset.assetModel}}</td>
          <td>{{asset.assetSerial}}</td>
          <td>{{asset.assetMemo}}</td>
        </tr>
        </tbody>
      </table>

      <h4 class="mt-20">출입위치</h4>
      <location-body class="outline m-t-sm" :selectIdcCode="item.visitIdcCode" :slectedIdcCodeList="getVisitLocationList"/>


    <h4 class="mt-20">기타</h4>
      <div class="result-tbl m-t-sm">
        <table class="tbl">
          <tbody>

            <tr>
            <col-field  label="차종">
              <Input :value="item.carModel" placeholder="차종"/>
            </col-field>
            <col-field  label="차량번호">
              <Input :value="item.carNumber" placeholder="차량번호"/>
            </col-field>
          </tr>
          <tr>
            <th>비고

            </th>
            <td>{{item.etc}}</td>
          </tr>
        </tbody></table>
      </div>
    </td>
  </tr>

</template>

<script>
import ColField from '@/components/ColField.vue';
import RowField from '@/components/RowField.vue';
import Input from "@/components/Input.vue"
import AssetList from './AssetList.vue';
import LocationList from './LocationList.vue';
import LocationBase from '@/components/common/locationBase'
import LocationBody from '../location/LocationBody.vue';


export default {
  mixins: [LocationBase],
  props: ['item'],
  components: {
    Input,
    ColField,
    RowField,
    AssetList,
    LocationList,
    LocationBody,
  },
  data() {
    return {
      statusDropList: [{name: '전체', value: null, isChecked: true}, {name: '담당임직원 승인대기', value: 1}, {name: '내부결재 진행중', value: 2}, {name: '승인완료', value: 3}, {name: '승인거절', value: 4}, {name: '입/퇴실완료', value: 4}],
    }
  },
  computed: {
    getVisitLocationList(){
      return JSON.parse(this.item.visitLocation)
    },
    getVisitType(){
      return (item) =>{
        if(item.visitType)
          return item.visitType.visitTypeStr
      }
    },
    getStatus(){
      return (item) => {
        var color = 'grey'
        if(item.statusCode == 1 || item.statusCode == 2)
          color = 'yellow';
        if(item.statusCode >= 3 && item.statusCode <= 8)
          color = 'green';
        if(item.statusCode == 4)
          color = 'red';
        return color;
      }
    },
    assetList(){
      var assetList = this.item.assetList;
      var visitorAssetList = this.item.assetList;
      return this.item.assetList;
    },
    // getVisitIdc(){
    //   return this.$store.getters['location/location'].filter(x=>x.locationCode == this.item.visitIdcCode)
    // },
    getLocationSoruce(){
      return (location, chekedLocation) =>{
        var locationList = this.getParseLocation(location);
        var chekedLocationList = this.getParseLocation(chekedLocation);
        locationList.forEach(x => {
          x.reserved = true;
          if(chekedLocationList.filter((y) => y.key == x.key).length > 0){

            x.checked = true;
          }
        });
        return locationList;
      }
    }
  },
  mounted(){
    this.init();
  },
  methods: {

    init(){

      var assetList = this.item.assetList || [];
      this.item.assetList.forEach(x=>{
        if(assetList.filter(z => z == x.visitorAssetIndex).length > 0){
          x.checked = true;
        }
      })
      /*
      if(this.$refs.assetList)
      this.$refs.assetList.$forceUpdate();
      */
    },
    // update() {
    //   var o = this.copyNew(this.item);
    //
    //   o.locationList = this.getStringLocationData(this.$refs.locationList.staticSource.filter((x) => x.checked));
    //
    //   o.assetList = _.map(o.visitor.assetList.filter(x => x.checked), z=>{
    //     return z.visitorAssetIndex;
    //   });
    //
    //   this.$http.put('/api/private/visitor/checkIn', o)
    //     .then((result) => {
    //       // this.$toast.success('입실정보가 수정되었습니다.');
    //       this.noti('완료', '입실 정보가 수정되었습니다.', 'success');
    //     }).catch((e) =>{
    //       console.log(e);
    //   })
    // },

  }
}
</script>

<style>

</style>
